import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["disabled"];
import { reactive, ref, watch } from 'vue';
import { ElMessage } from 'element-plus';
import { updateAsset } from '@/api/assets';
export default {
  __name: 'AssetEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    asset: {
      type: Object,
      default: null
    }
  },
  emits: ['update:visible', 'success'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;
    const form = reactive({
      name: '',
      description: '',
      status: 'NORMAL'
    });
    const submitting = ref(false);
    watch(() => props.visible, val => {
      if (val && props.asset) {
        form.name = props.asset.name || '';
        form.description = props.asset.description || '';
        form.status = props.asset.status || 'NORMAL';
      }
    });
    async function handleSubmit() {
      submitting.value = true;
      try {
        await updateAsset(props.asset.id, {
          name: form.name,
          description: form.description || undefined,
          status: form.status,
          lockVersion: props.asset.lockVersion
        });
        ElMessage.success('素材已更新');
        emit('success');
        emit('update:visible', false);
      } catch {
        // handled by interceptor
      } finally {
        submitting.value = false;
      }
    }
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        "model-value": __props.visible,
        title: "编辑素材",
        width: "480px",
        "close-on-click-modal": false,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _ctx.$emit('update:visible', $event))
      }, {
        footer: _withCtx(() => [_createElementVNode("button", {
          type: "button",
          class: "btn-secondary",
          onClick: _cache[3] || (_cache[3] = $event => _ctx.$emit('update:visible', false))
        }, "取消"), _createElementVNode("button", {
          type: "button",
          class: "btn-primary",
          disabled: !form.name || submitting.value,
          onClick: handleSubmit
        }, _toDisplayString(submitting.value ? '保存中...' : '保存'), 9, _hoisted_1)]),
        default: _withCtx(() => [__props.asset ? (_openBlock(), _createBlock(_component_el_form, {
          key: 0,
          model: form,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "名称",
            required: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.name = $event),
              placeholder: "素材名称",
              maxlength: "200"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "描述"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: form.description,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.description = $event),
              type: "textarea",
              rows: 3,
              placeholder: "简要描述",
              maxlength: "1000"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "状态"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_select, {
              modelValue: form.status,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.status = $event),
              class: "!w-32"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_option, {
                label: "正常",
                value: "NORMAL"
              }), _createVNode(_component_el_option, {
                label: "禁用",
                value: "DISABLED"
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};